/**
 * iso.tsx — hjelpere for isometriske SVG-illustrasjoner
 *
 * iso(x, y, z) projiserer tre-dimensjonale enheter til SVG-koordinater
 * («x» går ned til høyre, «y» ned til venstre, «z» opp). Box tegner en boks
 * som tre flater (topp, venstre, høyre); flatene får klassenavn fra kallsted.
 */

/** Skala (px per enhet) og origo i viewBox 760 x 520 */
const S = 34;
const OX = 380;
const OY = 290;

export function iso(x: number, y: number, z = 0): string {
  return `${(OX + (x - y) * 0.866 * S).toFixed(1)},${(OY + (x + y) * 0.5 * S - z * S).toFixed(1)}`;
}

interface BoxProps {
  x: number;
  y: number;
  z?: number;
  w: number;
  d: number;
  h: number;
  /** Klassenavn for flatene (tema-styrte farger) ... */
  top?: string;
  left?: string;
  right?: string;
  /** ... eller faste farger [topp, venstre, høyre] */
  colors?: [string, string, string];
  /** Egen projeksjon (for andre viewBox-er); standard er hero-scenen */
  project?: (x: number, y: number, z: number) => string;
}

export function Box({ x, y, z = 0, w, d, h, top, left, right, colors, project = iso }: BoxProps) {
  const p = project;
  return (
    <g>
      <polygon className={left} fill={colors?.[1]} points={`${p(x, y + d, z + h)} ${p(x + w, y + d, z + h)} ${p(x + w, y + d, z)} ${p(x, y + d, z)}`} />
      <polygon className={right} fill={colors?.[2]} points={`${p(x + w, y, z + h)} ${p(x + w, y + d, z + h)} ${p(x + w, y + d, z)} ${p(x + w, y, z)}`} />
      <polygon className={top} fill={colors?.[0]} points={`${p(x, y, z + h)} ${p(x + w, y, z + h)} ${p(x + w, y + d, z + h)} ${p(x, y + d, z + h)}`} />
    </g>
  );
}
